import { render, staticRenderFns } from "./CoozzySortableList.vue?vue&type=template&id=05ca72ac&scoped=true"
import script from "./CoozzySortableList.vue?vue&type=script&lang=js"
export * from "./CoozzySortableList.vue?vue&type=script&lang=js"
import style0 from "./CoozzySortableList.vue?vue&type=style&index=0&id=05ca72ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ca72ac",
  null
  
)

export default component.exports